<template>    
<section>


    <div class="portal">
      <div class="portal__block" v-for="(display, idx) in blocks" :key="idx">
          
          <label>Block name: </label>
          <input type="text" v-model="display.name" placeholder="Empty Block">

          <img @click="duplicateBlock(display)" class="icon space-around-1" src="/static/admin/duplicate.svg" alt="">
          <!-- <img class="icon space-around-1" src="/static/admin/text.svg" alt=""> -->
          <!-- <img @click="$parent.mediaBlock = !$parent.mediaBlock" class="icon" src="/static/admin/camera.svg" alt=""> -->
          <img class="icon space-around-1" src="/static/admin/code.svg" alt="">
          <div @click="$router.push('blocks/' + display.id)" class="portal__button space-around-1">edit</div>
          <div class="portal__options" :class="{bigIcon : display.options}">
            <div @click="deleteBlock(display)" v-if="display.options" class="x">x</div>
            <div @click="saveBlock(display)" v-if="display.options" class="save">save</div>

            <img @click="options(display)" class="icon"  src="/static/admin/options.svg" alt="">
          </div>

          <!-- {{display}} -->

      </div>


      <div @click="createBlock()" class="portal__add">
        <img src="/static/plus-01.svg" alt="">
        <div>add block</div>
      </div>



      
    </div>
    </section>
    </template>

    <script>
import { page } from 'vue-analytics'
import { firestore } from '../main'
import firebase from 'firebase'
import { Editor, EditorContent } from 'tiptap'



export default {
  data () {
    return {
      tools: false,
      blocks: {},
      editor: null,
      imageUrl: '',
      image: '',
      filename: ''
    }
  },
  components: {
    EditorContent
  },
  mounted() {
    this.editor = new Editor({
      content: '<p>This is just a boring paragraph</p>',
    })
  },
  beforeDestroy() {
    this.editor.destroy()
  },
  firestore() {
    return {
      blocks: firestore.collection("blocks").orderBy("createdAt")
    }
  },
  methods: {
    createBlock(){
      const createdAt = new Date()
      firestore.collection("blocks").add({createdAt: createdAt, options: false, lastEdited: createdAt})
    },
    options(display){
      display.options = !display.options
    },
    saveBlock(display){
      firestore.collection('blocks').doc(display.id).update(display)
      .then((data) => {
        firestore.collection('blocks').doc(display.id).update({options: false})
      })
    },
    duplicateBlock(display){
      const createdAt = new Date()
      firestore.collection('blocks').add(display)
      .then((data) => {
        firestore.collection('blocks').doc(data.id).update({id: data.id, name: display.name + ' copy', lastEdited: createdAt})
      })
    },
    deleteBlock(display){
      firestore.collection('blocks').doc(display.id).delete()
    }
  }
}
</script>
<style lang="scss">
  .bigIcon {
    border: 1px solid #aaa;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    transition: all .25s ease-in-out;
  }
  .x {
    position: absolute;
    background-color: #93923f;
    color: #fff;
    width: 25px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    top: -5px;
    left: 0;
    cursor: pointer;
  }
  .save {
    position: absolute;
    background-color: #93923f;
    color: #fff;
    padding: 2px 10px;
    width: auto;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 35px;
    bottom: -45px;
    right: 0;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/Blocks.vue